<template>
  <!-- 常见问题区域 -->
  <section class="faq-section">
    <div class="container">
      <h2 class="text-center title">常見問題</h2>
      <div class="row">
        <div class="col-md-6" v-for="item in faqs">
          <div class="content" >
            <div class="faq-section-content-header">
              <div class="faq-section-content-title" v-bind:class="{ 'faq-section-open': item.isShow }">{{ item.title }}</div>
              <div v-show="!item.isShow" @click="showPosFeatures(true, item)"><img class="submenu-icon" src="@/assets/uupay/icon/svg/plus.svg"></div>
              <div v-show="item.isShow" @click="showPosFeatures(false, item)"><img class="submenu-icon" src="@/assets/uupay/icon/svg/minus.svg"></div>
            </div>
            <div class="el-divider--horizontal el-divider" v-show="item.isShow"></div>
            <div class="detail" v-html="item.content" v-show="item.isShow">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'UUPayFaqs',
  data() {
    return {
      faqs: [
        {id: 1, title: '為何選擇UUPay？', isShow: false, 
        content: `高性价比：价格透明化，零隐藏成本<br>
                  采用完全透明的定价模式，无 POS 设备租借费、安装费及任何隐性收费项目，最大限度降低商户运营成本。<br>
                  高效管理：实时数据洞察，把握商业趋势<br>
                  通过 UUPay App，商户可随时查看业务数据、分析经营表现，精准捕捉市场趋势与业务机会，助力决策效率提升。<br>
                  操作便捷：一次申请，多元支付解决方案<br>
                  仅需一次申请，即可同步获得多种主流支付方式，无需重复对接，简化商户接入流程。<br>
                  客户体验流畅：支持 19 种主流支付方式<br>
                  覆盖 19 种主流支付渠道（如信用卡、电子钱包等），满足不同客户的支付习惯，提升交易成功率与消费体验。<br>
                  数据安全保障：国际认证的顶级防护体系<br>
                  支付解决方案严格遵循 PCI DSS Level 1（国际支付卡行业数据安全标准）与 ISO 27001（信息安全管理体系）认证，确保交易数据全程加密，守护商户与客户信息安全。<br>
                  全方位服务支持：从安装到售后全程无忧<br>
                  提供专业的 POS 设备安装指导与操作培训，同时通过热线电话与 WhatsApp 提供 7×12 小时专属客户服务，及时响应运营需求。<br>
                  灵活便携：双网络连接，适配多场景经营<br>
                  KPay 智能 POS 支持数据 SIM 卡与 Wi-Fi 双重联网模式，打破固定线路限制，无论是店内固定收银还是移动收款场景，均可轻松应对。`},
        {id: 2, title: '申請所需資料', isShow: false, 
        content: `商戶需要提交有效的身份證明文件、公司註冊證書（有限公司適用）、商業登記證、公司銀行戶口月結單及店舖照片等資料。詳情請向我們的銷售顧問團隊查詢。`},
        {id: 3, title: 'UUPay提供哪些服務？', isShow: false, 
        content: `UUPay針對不同行業提供不同種類的營運系統和工具涵蓋POS系統、客戶管理系統、營銷服務方案等`},
        {id: 4, title: '如何申請UUPay服務？', isShow: false, 
        content: `有意申請收款工具及服務的商戶，可以按此填妥業務資料，我們的業務銷售團隊會儘快跟你聯絡，並安排開通手續。`},
      ],
    }
  },
  methods: {
    showPosFeatures(isShow, item) {
      item.isShow = isShow
    }
  }
}
</script>
<style scoped>
.faq-section {
  margin-top: 66px;
  padding: 60px 0 100px 0;
  background-color: #f8f8f8;
}
.faq-section .title {
  font-size: 40px;
  font-weight: 600;
  padding: 68px 0;
}
.faq-section-content-header {
  display: flex;
  justify-content: space-between;
}
.faq-section-content-title {
  font-size: 20px;
  font-weight: 500;
}
.faq-section-open {
  color: #9A307A;
}
.faq-section .detail {
  color: #21042E;
  font-size: 12px;
}

@media (min-width: 1700px) {
  .faq-section .container {
    max-width: 1440px;
  }
}

.faq-section .content {
  margin: 0 50px 50px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/uupayFaqs.vue